export const iconFontAwesomeMedicalHealthReceipt = (
	<i className="fa-solid fa-receipt"></i>
);
